const Colors = {
  advanceBlue600: '#004C85',
  advanceBlue500: '#0069B8',
  advanceBlue400: '#0088ED',
  advanceBlue300: '#1F9FFF',
  advanceBlue200: '#85CBFF',
  advanceBlue100: '#B8E1FF',
  advanceBlue50: '#E5F4FF',
  advanceBlue10: '#F5FBFF',
  mint600: '#1E715A',
  mint500: '#29997A',
  mint400: '#34C39B',
  mint300: '#7EDDC2',
  mint200: '#92E2CC',
  mint100: '#A6E7D5',
  mint50: '#E3F7F2',
  mint10: '#F7FDFB',
  indigo600: '#1937A4',
  indigo500: '#1F46D0',
  indigo400: '#3F63E2',
  indigo300: '#99ACF0',
  indigo200: '#C5D0F6',
  indigo100: '#DCE2FA',
  indigo50: '#E9EDFC',
  indigo10: '#F6F8FE',
  purple600: '#44369B',
  purple500: '#5745BF',
  purple400: '#796BCC',
  purple300: '#9B91D9',
  purple200: '#CBC6EB',
  purple100: '#DDD9F2',
  purple50: '#EEECF8',
  purple10: '#F8F7FC',
  warning600: '#B26800',
  warning500: '#CC9900',
  warning400: '#BBCC00',
  warning300: '#F5C73D',
  warning200: '#FFD480',
  warning100: '#FFE6B3',
  warning80: '#F8D78C',
  warning50: '#FFF6E5',
  warning10: '#FFFCF5',
  success600: '#005718',
  success500: '#008A27',
  success400: '#00BB34',
  success300: '#0BCB41',
  success200: '#47F578',
  success100: '#A8FABF',
  success50: '#DDFDE6',
  success10: '#F5FEF8',
  error600: '#57000F',
  error500: '#8A0018',
  error400: '#BB0020',
  error300: '#D60025',
  error200: '#FF5774',
  error100: '#FFBDC8',
  error50: '#FFDBE1',
  error10: '#FFF5F7',
  gray600: '#29353D',
  gray500: '#3D4F5C',
  gray400: '#5F7A8E',
  gray300: '#7892A5',
  gray200: '#97ABBA',
  gray100: '#B6C4CE',
  lightGray500: '#C5D0D8',
  lightGray400: '#D4DCE2',
  lightGray300: '#E3E9ED',
  lightGray200: '#F3F5F7',
  lightGray100: '#F9FAFB',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent'
};
export default Colors;
//# sourceMappingURL=index.js.map